import { render, staticRenderFns } from "./SystemStatusAdd.vue?vue&type=template&id=0c8b6cb0&scoped=true&"
import script from "./SystemStatusAdd.vue?vue&type=script&lang=js&"
export * from "./SystemStatusAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8b6cb0",
  null
  
)

export default component.exports